import {
  DataSource,
  initialPageableData,
} from '@sharedModule/models/data-source.model';
import { RoleListInterface } from '../types/role-list';
import {
  RoleListFilter,
  defaultRoleListFilter,
} from '../types/role-list-filter';

export const ROLE_LIST_STATE = 'roleList';

export interface RoleListState {
  filter: RoleListFilter;
  dataSource: DataSource<RoleListInterface[]>;
}

export const initialDataSource: DataSource<RoleListInterface[]> = Object.freeze(
  {
    ...initialPageableData,
    rawData: [],
  }
);

export const initialRoleListState: RoleListState = Object.freeze({
  filter: defaultRoleListFilter,
  dataSource: {
    ...initialDataSource,
  },
});
